import React, { useState } from "react";
import './AMSEssentials.css';

function AMSEssentials() {
    const [readMore, setReadMore] = useState(false);

    return (
        <>
            <div className="overall-container">
                <div className="inner-box-container">
                    <img src={process.env.PUBLIC_URL + "/images/Monarch/AMSEssential/Beginners.png"} alt="" className="tile-img" />
                    <img src={process.env.PUBLIC_URL + "/images/Monarch/AMSEssential/week.png"} alt="" className="week-img" />
                    <h3 className="course-heading">AMS Essentials for Beginners</h3>
                    <p className="course-desc">Welcome to the AMS Essentials for Beignners. This program is designed for CL-13 to CL-11 participants that aims to understand about the Essentials of Application Management Services (AMS) for Beginners. This program covers various aspects like Application Maintenance Overview, understanding of Incident, Service Request, Problem, Change and Event Management, System Monitoring, Service Level Agreement (SLA), and Key Performance Indicator(KPI).</p>
                    <div className="course-details">
                        <div className="inner-details">
                            <img src={process.env.PUBLIC_URL + "/images/Monarch/AMSEssential/Duration.png"} alt="duration-icon" className="duration-icon" />
                            <span>8 hours</span>
                        </div>
                        <div className="inner-details">
                            <img src={process.env.PUBLIC_URL + "/images/Monarch/AMSEssential/selfpaced.png"} alt="self-paced icon" className="duration-icon" />
                            <span>Self-Paced</span>
                        </div>
                    </div>

                    {readMore ? (
                        <>
                            <div className="horizontal-course-divider"></div>
                            <ul className="course-list">
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">Application Overview</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">Incident management</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">Service request management</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">Problem and Change management</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">Service level agreement</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">System monitoring</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">Event management</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">Key Performace Indicator (KPI)</a></li>
                                <li><a href="https://deepknowledge.accenture.com/course/view.php?id=897" target="_blank">End of Course Assessment</a></li>
                            </ul>
                        </>
                    ) : ""
                    }
                    <p onClick={() => setReadMore(!readMore)} className="view-more">{readMore ? "View less ..." : "View more ..."}</p>
                </div>
                
            </div>
        </>
    );
}

export default AMSEssentials;
